const apiUrl = process.env.REACT_APP_API_URL;

const getOperatingSchedules = (token, cb) => {
    fetch(`${apiUrl}/operationsschedules`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getOperatingSchedules;
